import { FacebookRegularIcon as FacebookIcon, InstagramIcon, RedditIcon } from '@change/ds-icons';

const PLATFORM_ICONS = {
	facebook: {
		variant: 'facebook' as const,
		icon: FacebookIcon,
	},
	instagram: {
		variant: 'instagram' as const,
		icon: InstagramIcon,
	},
	reddit: {
		variant: 'reddit' as const,
		icon: RedditIcon,
	},
};

export const ICON_VARIANTS = {
	facebook_post: PLATFORM_ICONS.facebook,
	facebook_story: PLATFORM_ICONS.facebook,
	facebook_group_post: PLATFORM_ICONS.facebook,
	instagram_post: PLATFORM_ICONS.instagram,
	instagram_story: PLATFORM_ICONS.instagram,
	reddit_post: PLATFORM_ICONS.reddit,
	reddit_group_post: PLATFORM_ICONS.reddit,
};
